import './buttons.css';

//DECLARE HTML CLASS, ID, TAG VARIABLES
const destinationContainer = document.getElementById("destination__container");
const originContainer = document.getElementById("origin__container");
const words = document.getElementsByClassName("word");
const checkButton = document.getElementById("check_button");

let destinationPosDefault = destinationContainer.getBoundingClientRect();

//DECLARE CODE VARIABLES
//store coordinates of the words by order of their placement.
let destinationArray = [];

//store coordinates of the words in the origin array
const originArray = [];

export function makeButtons(solution, wrong, callback){
  printWords(solution, wrong);
  animateButtons()
  checkButtonClick(solution, callback)
}

function shuffle(arr){
  let i = arr.length, j, temp;
  while (--i > 0) {
    j = Math.floor(Math.random() * (i + 1));
    temp = arr[j];
    arr[j] = arr[i];
    arr[i] = temp;
  }
  return arr;
}

//Print the list of words   **
function printWords(solution, wrong){

  const arr = [
    ...solution.flat(),
    ...wrong
    //String.fromCharCode(parseInt('2800', 16)) // blank
  ];

  const listOfWords = shuffle(arr);

  for (let i = 0; i < listOfWords.length; i++) {

    if (listOfWords[i] == 0) continue;

    const wordNode = document.createElement("div");
    wordNode.textContent = listOfWords[i];
    wordNode.classList.add("word");
    originContainer.appendChild(wordNode);
  }
}

function calibrateDestinationCursorPos(destinationArray) {
  //When no word is clicked on
  if (destinationArray.length === 0) {
    return destinationPosDefault.x;
  } else {
    //if word is placed in the destination, fetch coordinates of last word
    //as starting point for the next word.
    let sum = destinationPosDefault.x;
    destinationArray.forEach((element) => {
      sum += element.width + 20; //add 20px for the spacing
    });
    return sum;
  }
}

export function resetDestination(){
    // animate buttons back to original position
    [...originContainer.children].forEach((e) =>  e.style = '');
    // update location of buttons
    originArray.forEach((e) => e.location = "origin");
    // clear destinationArray
    destinationArray.length = 0;
  };

function createOriginArray(word) {
  let wordPosition = word.getBoundingClientRect();
  let newWordObject = Object.assign(wordPosition);
  newWordObject.word = word.textContent;
  newWordObject.location = "origin";
  originArray.push(newWordObject);
}

function animateButtons(){
  for (let i = 0; i < words.length; i++) {
    createOriginArray(words[i]);

    words[i].addEventListener("click", () => {
      //Check de destinationStartPos
      let destinationStartPos = calibrateDestinationCursorPos(destinationArray);

      //Calculate X and Y distance between destination and the word
      let yTravel =
        originArray[i].y -
        (destinationPosDefault.y +
          (destinationPosDefault.height - originArray[i].height) / 2);

      let xTravel = 0;
      if (originArray[i].x > destinationStartPos) {
        xTravel = -(originArray[i].x - destinationStartPos);
      } else {
        xTravel = destinationStartPos - originArray[i].x;
      }

      if (originArray[i].location === "origin") {
        originArray[i].location = "destination";
        //Put the word object in the destination array
        destinationArray.push(originArray[i]);
      } else if (originArray[i].location === "destination") {
        yTravel = 0;
        xTravel = 0;
        originArray[i].location = "origin";
        //delete the word from the destination Array
        let test = destinationArray.filter(
          (wordObject) => wordObject.word !== originArray[i].word
        );
        destinationArray = test;
      }

      //Apply translate
      words[i].style.transform = `translate(${xTravel}px,-${yTravel}px)`;
    });
  }
}

function checkButtonClick(arr, callback){
  checkButton.addEventListener("click", () => {

      let answer = destinationArray.map(e => {
          return e['word']
      });

      callback(arr, answer);

      //console.log('solution is ' + arr);
      //console.log('answer is ' + answer);

      //console.log(compareArrays(answer, arr))
      
  });
}